import React from "react";


const Home: React.FC = () => {

  return (
    <div className="h-screen flex items-center justify-center">
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-2xl font-bold mb-6 text-center">
          Welcome to Shirohana
        </h1>
      </div>
    </div>
  );
};

export default Home;
